import { render } from "./FileView.vue?vue&type=template&id=e651c974"
import script from "./FileView.vue?vue&type=script&lang=ts"
export * from "./FileView.vue?vue&type=script&lang=ts"
script.render = render

export default script